export function Help() {
  return (
    <div className='relative overflow-hidden bg-white py-16'>
      <div className='hidden lg:absolute lg:inset-y-0 lg:block lg:h-full lg:w-full lg:[overflow-anchor:none]'>
        <div className='relative mx-auto h-full max-w-prose text-lg' aria-hidden='true'>
          <svg
            className='absolute top-12 left-full translate-x-32 transform'
            width={404}
            height={384}
            fill='none'
            viewBox='0 0 404 384'
          >
            <defs>
              <pattern
                id='74b3fd99-0a6f-4271-bef2-e80eeafdf357'
                x={0}
                y={0}
                width={20}
                height={20}
                patternUnits='userSpaceOnUse'
              >
                <rect
                  x={0}
                  y={0}
                  width={4}
                  height={4}
                  className='text-gray-200'
                  fill='currentColor'
                />
              </pattern>
            </defs>
            <rect width={404} height={384} fill='url(#74b3fd99-0a6f-4271-bef2-e80eeafdf357)' />
          </svg>
          <svg
            className='absolute top-1/2 right-full -translate-y-1/2 -translate-x-32 transform'
            width={404}
            height={384}
            fill='none'
            viewBox='0 0 404 384'
          >
            <defs>
              <pattern
                id='f210dbf6-a58d-4871-961e-36d5016a0f49'
                x={0}
                y={0}
                width={20}
                height={20}
                patternUnits='userSpaceOnUse'
              >
                <rect
                  x={0}
                  y={0}
                  width={4}
                  height={4}
                  className='text-gray-200'
                  fill='currentColor'
                />
              </pattern>
            </defs>
            <rect width={404} height={384} fill='url(#f210dbf6-a58d-4871-961e-36d5016a0f49)' />
          </svg>
          <svg
            className='absolute bottom-12 left-full translate-x-32 transform'
            width={404}
            height={384}
            fill='none'
            viewBox='0 0 404 384'
          >
            <defs>
              <pattern
                id='d3eb07ae-5182-43e6-857d-35c643af9034'
                x={0}
                y={0}
                width={20}
                height={20}
                patternUnits='userSpaceOnUse'
              >
                <rect
                  x={0}
                  y={0}
                  width={4}
                  height={4}
                  className='text-gray-200'
                  fill='currentColor'
                />
              </pattern>
            </defs>
            <rect width={404} height={384} fill='url(#d3eb07ae-5182-43e6-857d-35c643af9034)' />
          </svg>
        </div>
      </div>
      <div className='relative px-4 sm:px-6 lg:px-8'>
        <div className='mx-auto max-w-prose text-lg'>
          <h1>
            <span className='block text-center text-lg font-semibold text-indigo-600'>
              Step by Step Videos
            </span>
            {/* <span className='mt-2 block text-center text-3xl font-bold leading-8 tracking-tight text-gray-900 sm:text-4xl'>
              Video 1: X
            </span> */}
          </h1>
          {/* <p className='mt-8 text-xl leading-8 text-gray-500'>
            Aliquet nec orci mattis amet quisque ullamcorper neque, nibh sem. At arcu, sit dui mi,
            nibh dui, diam eget aliquam. Quisque id at vitae feugiat egestas ac. Diam nulla orci at
            in viverra scelerisque eget. Eleifend egestas fringilla sapien.
          </p> */}
        </div>
        <div className='prose prose-lg prose-indigo mx-auto mt-6 text-gray-500'>
          <h2>Set up a Crypto/Web3 wallet</h2>
          <div className='w-full flex justify-center'>
            <iframe
              width='560'
              height='315'
              src='https://www.youtube.com/embed/GNPz-Dv5BjM'
              title='Set up a wallet'
              frameBorder='0'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              allowFullScreen
            ></iframe>
          </div>
          <h2>Connect your wallet</h2>
          <div className='w-full flex justify-center'>
            <iframe
              width='560'
              height='315'
              src='https://www.loom.com/embed/33f3e7f7d36e4abc91468037dd944187'
              title='Connect your wallet'
              frameBorder='0'
              webkitallowfullscreen='true'
              mozallowfullscreen='true'
              allowFullScreen
            ></iframe>
          </div>
          <h2>Ask a question</h2>
          <div className='w-full flex justify-center'>
            <iframe
              width='560'
              height='315'
              src='https://www.loom.com/embed/1a5b6653ba4c431c97565e7676ed6c16'
              title='Ask a question'
              frameBorder='0'
              webkitallowfullscreen='true'
              mozallowfullscreen='true'
              allowFullScreen
            ></iframe>
          </div>
          <h2>Update your profile</h2>
          <div className='w-full flex justify-center'>
            <iframe
              width='560'
              height='315'
              src='https://www.loom.com/embed/00cda100ea71482b9f1c561ee54a23e4'
              title='Update your profile'
              frameBorder='0'
              webkitallowfullscreen='true'
              mozallowfullscreen='true'
              allowFullScreen
            ></iframe>
          </div>
          <h2>Answer a question</h2>
          <div className='w-full flex justify-center'>
            <iframe
              width='560'
              height='315'
              src='https://www.loom.com/embed/dabe68b18f8940039ea8a7bec993392c'
              title='Answer a question'
              frameBorder='0'
              webkitallowfullscreen='true'
              mozallowfullscreen='true'
              allowFullScreen
            ></iframe>
          </div>
          <h2>Withdraw your earnings</h2>
          <div className='w-full flex justify-center'>
            <iframe
              width='560'
              height='315'
              src='https://www.loom.com/embed/626f0a27acbb4515b36a731134e9b7b5'
              title='Withdraw your earnings'
              frameBorder='0'
              webkitallowfullscreen='true'
              mozallowfullscreen='true'
              allowFullScreen
            ></iframe>
          </div>
          {/* <p>
            Id orci tellus laoreet id ac. Dolor, aenean leo, ac etiam consequat in. Convallis arcu
            ipsum urna nibh. Pharetra, euismod vitae interdum mauris enim, consequat vulputate nibh.
            Maecenas pellentesque id sed tellus mauris, ultrices mauris. Tincidunt enim cursus
            ridiculus mi. Pellentesque nam sed nullam sed diam turpis ipsum eu a sed convallis diam.
          </p> */}
        </div>
      </div>
    </div>
  );
}
